export default "__VITE_ASSET__CM5Zgdzf__"